import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import * as utils from "../../_metronic/utils/utils";

const LastLocationContext = createContext(null);

const localStorageLastLocationKey = "demo2-lastLocation";

function acceptLocation(lastLocation) {
  if (
    lastLocation &&
    lastLocation.pathname &&
    lastLocation.pathname !== "/" &&
    lastLocation.pathname.indexOf("auth") === -1 &&
    lastLocation.pathname !== "/logout"
  ) {
    return true;
  }
  return false;
}

function saveLastLocation(lastLocation) {
  const localStorateLocations = utils.getStorage(localStorageLastLocationKey);
  let _useLocations = localStorateLocations
    ? JSON.parse(localStorateLocations)
    : [];

  if (acceptLocation(lastLocation)) {
    _useLocations.push(lastLocation.pathname);
    utils.setStorage(
      localStorageLastLocationKey,
      JSON.stringify(_useLocations),
      120
    );
  }
}

export function getLastLocation(isAdmin) {
  const localStorateLocations = utils.getStorage(localStorageLastLocationKey);
  if (!localStorateLocations) {
    return "/";
  }

  const _userLocations = isAdmin ? JSON.parse(localStorateLocations) : [];
  const result = _userLocations.length > 0 ? _userLocations.pop() : "/";
  return result;
}

export function LastLocationProvider({ children }) {
  const location = useLocation();
  const [lastLocation, setLastLocation] = useState(null);
  const prevLocationRef = useRef(null);

  useEffect(() => {
    if (prevLocationRef.current && prevLocationRef.current.pathname !== location.pathname) {
      const previousLocation = prevLocationRef.current;
      setLastLocation(previousLocation);
      saveLastLocation(previousLocation);
    }
    prevLocationRef.current = location;
  }, [location]);

  return (
    <LastLocationContext.Provider value={lastLocation}>
      {children}
    </LastLocationContext.Provider>
  );
}

export function useLastLocation() {
  const context = useContext(LastLocationContext);
  return context;
}

